<template>
    <div>
        <div id="navigation">

            <div class="desktop">
                <a href="/#philosophy">Philosophie</a>
                <a href="/#overview">Alles im Überblick</a>
                <router-link to="/" id="logo"><img src="../assets/logo.png" alt="Logo Herdenschutz"></router-link>
                <a href="/#sensitive-data">Sensible Daten</a>
                <a href="/#contact">Kontakt</a>

                <div class="social">
                    <!-- <a href="#Instagram" target="_blank"><img src="instagram.png"></a> -->
                    <a href="https://www.facebook.com/herdenschutz/" target="_blank" rel="noopener"><img src="facebook.png" alt="Logo Facebook"></a>
                    <a href="mailto:info@herdenschutz.net"><img src="mail.png" alt="E-Mail Icon"></a>
                </div>
            </div>

            <div class="mobil">
                <a href="/" id="logo"><img src="../assets/logo.png" alt="Logo Herdenschutz"></a>

                <div class="hamburger" :class="{'active': showNavigation}" @click="showNavigation = !showNavigation">
                    <div class="line1"></div>
                    <div class="line2"></div>
                    <div class="line3"></div>
                </div>
            </div>

        </div>

        <div class="overlay mobil" :class="{'active': showNavigation}">
            <a href="/#philosophy" @click="showNavigation = false">Philosophie</a>
            <a href="/#overview" @click="showNavigation = false">Alles im Überblick</a>
            <a href="/#sensitive-data" @click="showNavigation = false">Sensible Daten</a>
            <a href="/#contact" @click="showNavigation = false">Kontakt</a>
        </div>
    </div>
</template>

<style scoped>
a, a:visited, a:link, a:active {
    display: inline-block;
    line-height: 1em;
    margin: 0 2em;
    vertical-align: middle;
    margin-top: 1em;
}

div#navigation {
    line-height: 7em;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    box-shadow: 0 0 1em #ccc;
    z-index: 10;
    background: #ffffff;
}

div > div.social {
    position: absolute;
    right: 8em;
    top: 0;
}

div > div.social a {
    margin-left: auto;
    margin-right: auto;
}

.social img {
    height: 2em;
}

a#logo {
    margin: 0;
}

a#logo img {
    height: 6em;
    margin: -2em 1em;
}

div.hamburger {
    width: 1em;
    height: 1em;
    float: right;
    margin-top: .75em;
    margin-right: 1em;
    position: relative;
    font-size: 3em;
}

div.hamburger div.line1,
div.hamburger div.line2,
div.hamburger div.line3 {
    position: absolute;
    left: 0;
    top: 0;
    height: .15em;
    width: 1em;
    background: #000000;
    border-radius: 1em;
    transition: all .25s ease-in-out;
    transform-origin: left center;
}

div.hamburger div.line2 {
    top: calc(50% - .15em);

}

div.hamburger div.line3 {
    top: calc(100% - .3em);
}

div.hamburger.active div.line1 {
    transform: rotate(45deg);
}

div.hamburger.active div.line2 {
    opacity: 0;
}

div.hamburger.active div.line3 {
    transform: rotate(-45deg);
}

div.overlay {
    position: fixed;
    top: 0;
    left: 100vw;
    width: 100vw;
    height: 100vh;
    background: #ffffff;
    padding-top: 8em;
    z-index: 8;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    transition: all .25s ease-in-out;
}

div.overlay.active {
    left: 0;
}

div.overlay a {
    display: block;
    font-size: 2em;
    margin-bottom: 2em;
}

@media only screen and (max-width: 760px) {
    div#navigation {
        text-align: left;
    }
}

/*
#nav a.router-link-exact-active {
  color: #42b983;
}
*/
</style>

<script>
export default {
    data: () => {
        return {
            showNavigation: false
        }
    }
}
</script>